import axios from "@/api/axiosAuthRequired.js"

export const fetchGames = () => {
  return axios({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/pg-resources/games",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchUserProfileAvatars = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/pg-resources/user-profile/avatars",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/pgResources.js